import { render, staticRenderFns } from "./PingShenInfo.vue?vue&type=template&id=1926a5a6&scoped=true"
import script from "./PingShenInfo.vue?vue&type=script&lang=js"
export * from "./PingShenInfo.vue?vue&type=script&lang=js"
import style0 from "./PingShenInfo.vue?vue&type=style&index=0&id=1926a5a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1926a5a6",
  null
  
)

export default component.exports